import { createStore } from '@stencil/store';
import { RenderDataSource } from '../data/data.types';

export class webDesignerMsg {
  mid: string = '';
  type: string = 'webDesignerMsg';
  method?: string = "";
  payload: any = {};
}

const initialState = {
    domainName: "",
    selectedId: 'root',
    reRender: {
      instanceId: '',
      prop: ''
    },
    resizeObserver: {} ,
    dataLoader: {
      instanceId: '',
      prop: '',
      renderData: new RenderDataSource()
    },
    componenentDesign: false,
    msgReg: new webDesignerMsg()
};

const { state, onChange, reset } = createStore(initialState);

export const commonStore = {
  state,
  onChange,
  reset,
};

